import Action from '../actions' 

var initialState = {
    dynamic: "",
    visible_dynamic:false
}

function dynamicReducer(state = initialState, action) {
    switch (action.type) {
        case Action.DATA_DYNAMIC:
            return {
                ...state,
                dynamic: action.dynamic,
                visible_dynamic: action.visible_dynamic
            }
        default:
            return state
    }
}

export default dynamicReducer;